import React from 'react';
const SoqlBotResponseLoader = ({ statusMessage }) => (React.createElement("div", { className: "soql-response-loader" },
    React.createElement("div", { className: "chatbot-input-icon-container" },
        React.createElement("svg", { className: "chatbot-input-icon", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            ' ',
            React.createElement("path", { d: "M10.6 9.6L9 15L7.4 9.6L2 8L7.4 6.4L9 1L10.6 6.4L16 8L10.6 9.6ZM17 14.2L21 12L18.8 16L21 20L17 17.8L13 20L15.2 16L13 12L17 14.2ZM10 16L8.3 19L10 22L7 20.3L4 22L5.7 19L4 16L7 17.7L10 16Z", fill: "#3F51B5" }),
            ' ')),
    statusMessage || 'Generating your answer'));
export default SoqlBotResponseLoader;
//# sourceMappingURL=SoqlBotResponseLoader.js.map